(function () {
  if (window.mylineCollectionColumnsReady) return;
  window.mylineCollectionColumnsReady = true;

  const key = 'myline:collection-columns:v1';
  let selected;

  try {
    selected = sessionStorage.getItem(key);
  } catch (_) {}

  function restore() {
    const buttons = Array.from(
      document.querySelectorAll('.per-row__button[data-per-row]')
    );

    if (
      !selected ||
      !buttons.some(button => button.dataset.perRow === selected)
    ) {
      return;
    }

    buttons.forEach(button => {
      button.classList.toggle(
        'active',
        button.dataset.perRow === selected
      );
    });

    document
      .querySelectorAll('[data-productis-in-row]')
      .forEach(grid => {
        grid.setAttribute('data-productis-in-row', selected);
      });
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest(
      '.per-row__button[data-per-row]'
    );

    if (!button) return;

    selected = button.dataset.perRow;

    try {
      sessionStorage.setItem(key, selected);
    } catch (_) {}

    restore();
  });

  window.addEventListener('pageshow', restore);
  document.addEventListener('shopify:section:load', restore);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restore);
  } else {
    restore();
  }

  new MutationObserver(function (records) {
    if (
      records.some(record =>
        Array.from(record.addedNodes).some(node =>
          node.nodeType === 1 &&
          (
            node.matches(
              '[data-productis-in-row], .per-row__button'
            ) ||
            node.querySelector(
              '[data-productis-in-row], .per-row__button'
            )
          )
        )
      )
    ) {
      restore();
    }
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();